{
  "table": {
    "newBanner": "Nouvelle bannière",
    "name": "Nom",
    "roleProfiles": "Profils de rôle",
    "lastUpdated": "Dernière mise à jour",
    "activeDateRange": "Période d'activité",
    "status": {
      "title": "Statut",
      "states": {
        "DRAFT": "Brouillon",
        "SCHEDULED": "Planifiée",
        "ACTIVE": "Active",
        "EXPIRED": "Expirée"
      }
    },
    "organization": "Organisation",
    "actions": {
      "delete": "Supprimer",
      "setToDraft": "Définir comme brouillon"
    }
  },
  "useParentAlertBanners": "Hériter des bannières d'alerte de l'organisation parente",
  "alertBanner": "bannière d'alerte",
  "newBanner": "Nouvelle bannière d'alerte",
  "editBanner": "Modifier la bannière d'alerte",
  "transitionError": "Cette bannière n'est plus disponible",
  "bannerForm": {
    "name": "Nom",
    "roleProfile": {
      "title": "Profil(s) de rôle",
      "placeholder": "Sélectionnez toutes les options applicables"
    },
    "bannerType": {
      "title": "Type de bannière",
      "INFO": "Info : À utiliser pour les informations sur les nouvelles fonctionnalités, les mises à jour d'applications, etc.",
      "SUCCESS": "Succès : À utiliser pour communiquer un événement positif ou affirmatif.",
      "WARNING": "Avertissement : À utiliser pour les informations de haute priorité, telles que la maintenance système à venir.",
      "URGENT": "Urgent : À utiliser pour les communications urgentes, telles qu'une alerte de fraude ou de sécurité."
    },
    "bannerCopy": {
      "title": "Texte de la bannière (limite de 150 caractères)",
      "placeholder": "Saisissez le texte de la bannière ici"
    },
    "configuration": {
      "displayOnWeb": "Afficher sur le portail web",
      "displayOnIOS": "Afficher sur l'application iOS",
      "displayOnAndroid": "Afficher sur l'application Android",
      "makeDismissible": "Rendre masquable",
      "enableAction": "Activer le bouton d'action"
    },
    "actionButton": {
      "url": "URL",
      "label": "Libellé du bouton",
      "urlError": "Saisissez une URL valide commençant par http:// ou https://"
    },
    "persistenceBehaviour": {
      "title": "Comportement de persistance",
      "FIRST_SESSION": {
        "title": "Afficher lors de la première session",
        "description": "Afficher la première fois que l'utilisateur se connecte, mais pas lors des sessions suivantes."
      },
      "EVERY_SESSION": {
        "title": "Afficher à chaque session",
        "description": "Afficher lors de chaque nouvelle session dans la période d'activité, même si l'utilisateur masque la bannière."
      },
      "UNTIL_DISMISSED": {
        "title": "Afficher jusqu'à masquage",
        "description": "Afficher lors de chaque session jusqu'à ce que l'utilisateur masque la bannière."
      },
      "UNTIL_ACTIONED": {
        "title": "Afficher jusqu'à action",
        "description": "Afficher lors de chaque session jusqu'à ce que l'utilisateur clique sur le bouton d'action associé."
      }
    },
    "activeDateRange": {
      "startDate": "Heure de début ({{timeZone}})",
      "endDate": "Heure de fin ({{timeZone}})"
    },
    "actions": {
      "preview": {
        "title": "Aperçu",
        "close": "Fermer"
      },
      "saveDraft": "Enregistrer le brouillon",
      "scheduleBanner": "Planifier la bannière",
      "updateBanner": "Mettre à jour la bannière",
      "activateImmediately": {
        "title": "Activer immédiatement",
        "description": "La période d'activité inclut la journée en cours, ce qui signifie que la bannière s'affichera immédiatement.",
        "cancel": "Annuler",
        "confirm": "Confirmer"
      },
      "toasts": {
        "draftSaved": "Brouillon enregistré.",
        "bannerStatus": "La nouvelle bannière d'alerte a été {{status}}.",
        "activated": "activée",
        "scheduled": "planifiée"
      }
    }
  },
  "filterModal": {
    "title": "Filtrer",
    "status": "Statut",
    "cancel": "Annuler",
    "apply": "Appliquer",
    "showStatus": "Afficher {{status}}"
  },
  "alertBannerDeleteModal": {
    "deleteAlertBanner": "Supprimer la bannière d'alerte ?",
    "untitled": "Sans titre",
    "wantToProceed": "Vous êtes sur le point de supprimer la bannière d'alerte {{name}}. Cette action est irréversible.",
    "deletedSuccessfully": "Bannière d'alerte supprimée avec succès.",
    "setToDraftSuccessfully": "Bannière d'alerte définie comme brouillon avec succès."
  }
}
